import TriangleIcon from 'assets/icons/yellow-warning.svg?react';
import GreenCheckIcon from 'assets/icons/green-check.svg?react';
import ClockIcon from 'assets/icons/clock.svg?react';
import { IdentificationStatusProps } from './types';

export default function getIcon(
  type: IdentificationStatusProps['type'],
  className?: string,
) {
  switch (type) {
    case 'warning':
      return <TriangleIcon className={className} data-test="icon-warning" />;
    case 'waiting':
      return <ClockIcon className={className} data-test="icon-waiting" />;
    case 'success':
      return <GreenCheckIcon className={className} data-test="icon-success" />;
    default:
      return null;
  }
}
